import { useEffect, useState } from "react";
import UnAuthorizedLayout from "../../layout/unauth/UnAuthorizedLayout";
import styles from "./styles.module.css";
import useMediaQuery from "../../../app/common/hooks/useMediaQuery";
import { VendorLoginForm } from "../../../app/models/user";
import { ErrorMessage, Form, Formik } from "formik";
import { authSchema } from "../../../app/validation/validationSchema";
import { InputTemp } from "../../../app/common/form/Custom";
import { Button, Label } from "semantic-ui-react";
import { ReactComponent as HidePwd } from "../../../assets/hide.svg";
import { ReactComponent as ShowPwd } from "../../../assets/show.svg";
import { ReactComponent as LogoSvg } from "../../../assets/altlogo.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PlaySvg } from "../../../assets/play.svg";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import { Alert } from "react-bootstrap";
import agent from "../../../app/api/agent";
import { decrypt } from "crypto-js/aes";

const LoginPage = () => {
  const matches = useMediaQuery("(min-width: 800px)");
  const navigate = useNavigate();
  const [inputField] = useState(new VendorLoginForm());
  const [showPwd, setShowPwd] = useState(false);
  const { userStore, commonStore } = useStore();
  const { login, loginStatus } = userStore;
  const { GetItem } = commonStore;
  const token: string | null = GetItem("jwt");
  const [resInfo, setResInfo] = useState<{
    status: boolean | null;
    message: string;
  }>({
    status: false,
    message: "",
  });




  const clearError = () => {
    // console.log("cleared")
    setResInfo({
      status: null,
      message: "",
    });
  };
  useEffect(() => {
    if (token) {
      navigate("/vendor/dashboard");
    }
  }, [navigate, token]);
  if (token) return <Loading />;

  return (
    <UnAuthorizedLayout>
      {loginStatus === "loading" && <Loading />}
      <div className={styles.page}>
        {/* <img
          src={altlogo}
          style={{
            width: matches ? "150px" : "150px",
            marginLeft: matches ? "10px" : "5px",
            cursor: "pointer",
          }}
          alt="logo"
        /> */}
        {matches && <LogoSvg />}
        <div className={styles.header}>Vendor Login</div>
        <div className={styles.required}></div>
        <Formik
          initialValues={inputField}
          enableReinitialize
          onSubmit={(values) => {
            clearError();
            login(values).catch((error: string) =>
              setResInfo({
                status: true,
                message: error,
              })
            );
          }}
          validationSchema={authSchema.login}
        >
          {({
            dirty,
            touched,
            errors,
            getFieldProps,
            handleSubmit,
            values,
            setFieldValue,
            isValid,
            isSubmitting,
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <InputTemp
                  label="Email Address"
                  labelStyle={{
                    fontFamily: "Montserrat",
                    color: "#828282 !important",
                    fontSize: "14px",
                  }}
                  inputType={"email"}
                  placeholder="email@host.co.."
                  {...getFieldProps("email")}
                  name="email"
                />
                <ErrorMessage
                  name={"email"}
                  render={(error) => (
                    <Label basic color="red" content={error} />
                  )}
                />
                <InputTemp
                  visibilityPadding
                  label="Password"
                  labelStyle={{
                    fontFamily: "Montserrat",
                    color: "#828282 !important",
                    fontSize: "14px",
                    paddingTop: "10px",
                  }}
                  placeholder="Enter Password"
                  inputType={showPwd ? "text" : "password"}
                  {...getFieldProps("password")}
                  name="password"
                >
                  <i
                    className={styles.btnVisibility}
                    onClick={() => setShowPwd((state) => !state)}
                  >
                    {showPwd ? <ShowPwd /> : <HidePwd />}
                  </i>
                </InputTemp>
                <ErrorMessage
                  name={"password"}
                  render={(error) => (
                    <Label basic color="red" content={error} />
                  )}
                />
                <div className={styles.sterlinks}>
                  <span onClick={() => navigate("/change-password")}>
                    Forgot Password?
                  </span>{" "}
                </div>
                <div className={styles.next}>
                  {resInfo.status && touched && dirty && (
                    <Alert variant="danger" onClose={clearError} dismissible>
                      {resInfo.message}
                    </Alert>
                  )}
                  <Button
                    positive
                    className={styles.positive}
                    disabled={!dirty || !isValid}
                    type="submit"
                    loading={loginStatus === "loading"}
                  >
                    <div className={styles.button}>
                      <span>Login to your Account</span>
                      <PlaySvg />
                    </div>
                  </Button>
                </div>
                <div
                  className={styles.signUp}
                  onClick={() => navigate("/register")}
                >
                  <p>Create a new account</p>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </UnAuthorizedLayout>
  );
};

export default observer(LoginPage);
